export const objectSizeCameraPos = {
  small: {
    landscape: "1.1m",
    portrait: "0.9m",
  },
  medium: {
    landscape: "2.5m",
    portrait: "1.7m",
  },
  large: {
    landscape: "3m",
    portrait: "2.5m",
  },
  custom: {
    landscape: "3m",
    portrait: "2.2m",
  },
};
